import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const SideNav = ({ isCollapsed = false, onToggle, activeTab, onTabChange, isAdmin = false }) => {
  const navigate = useNavigate()
  const [activeItem, setActiveItem] = useState(activeTab || 'my-templates')

  const allMenuItems = [
    {
      id: 'dashboard',
      name: 'Dashboard',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
        </svg>
      ),
      path: '/dashboard'
    },
    {
      id: 'my-templates',
      name: 'My Templates',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
        </svg>
      ),
      path: '/my-templates'
    },
    {
      id: 'all-templates',
      name: 'All Templates',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" />
        </svg>
      ),
      path: '/all-templates'
    },
    {
      id: 'calendar',
      name: 'Calendar',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
        </svg>
      ),
      path: '/calendar'
    },
    {
      id: 'import-from-legacy',
      name: 'Import from Legacy',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z" />
        </svg>
      ),
      path: '/templates/import-from-legacy'
    },
    {
      id: 'audio',
      name: 'Audio',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M9 4.804A4 4 0 0114 8v5a3 3 0 11-2-2.816V8a2 2 0 10-4 0v6a3 3 0 11-2-2.816V8a6 6 0 016-6v2a4 4 0 00-3 0z" clipRule="evenodd" />
        </svg>
      ),
      path: '/audio'
    },
    {
      id: 'background-removal',
      name: 'Background Removal',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd" />
          <path d="M8 8a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      path: '/background-removal'
    },
    {
      id: 'mini-photoshop',
      name: 'MiniPhotoShop',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm1 2h10l-2 4-2-3-2 3-2-3L5 5zm0 6h10v4H5v-4z" />
        </svg>
      ),
      path: '/mini-photoshop'
    },
    {
      id: 'photos',
      name: 'Photos',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd" />
        </svg>
      ),
      path: '/photos'
    },
    {
      id: 'graphics',
      name: 'Graphics',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm0 2h12v8H4V6z" clipRule="evenodd" />
        </svg>
      ),
      path: '/graphics'
    },
    {
      id: 'videos',
      name: 'Videos',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h7a2 2 0 002-2v-1l3 2V7l-3 2V6a2 2 0 00-2-2H4z" />
        </svg>
      ),
      path: '/videos'
    },
    {
      id: 'font-preview',
      name: 'Font Preview',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      ),
      path: '/font-preview'
    },
    {
      id: 'category-management',
      name: 'Categories',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
        </svg>
      ),
      path: '/categories'
    },
    {
      id: 'tenant-management',
      name: 'Tenants',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm2 6a2 2 0 114 0 2 2 0 01-4 0zm8 0a2 2 0 114 0 2 2 0 01-4 0z" />
        </svg>
      ),
      path: '/tenants'
    },
    {
      id: 'user-management',
      name: 'Users',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      path: '/users'
    },
    {
      id: 'tenant-template-management',
      name: 'Template Assignments',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
        </svg>
      ),
      path: '/template-assignments'
    },
    {
      id: 'tenant-watermark-templates',
      name: 'Watermark Templates',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd" />
        </svg>
      ),
      path: '/tenant-watermark-templates'
    }
  ]

  // Filter menu items based on user role
  const menuItems = allMenuItems.filter(item => {
    // Hide 'Users' menu from MANAGER and USER roles (only show to ADMIN)
    if (item.id === 'user-management') {
      return isAdmin
    }
    return true
  })

  // Admin menu items
  const adminItems = [
    {
      id: 'template-management',
      name: 'Manage Templates',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
        </svg>
      ),
      path: '/admin/templates'
    },
    {
      id: 'multi-template-generator',
      name: 'Multi Template Generator',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
        </svg>
      ),
      path: '/dashboard/multi-template-generator'
    },
    {
      id: 'ai-generator',
      name: 'AI Generator',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M10 2a1 1 0 011 1v1.323l3.954 1.582 1.599-.8a1 1 0 01.894 1.79l-1.233.616 1.738 3.476a1 1 0 01-.447 1.342l-3 1.5a1 1 0 01-1.342-.448l-1.738-3.476-.425.212V13a1 1 0 11-2 0V9.117l-.425-.213-1.738 3.477a1 1 0 01-1.342.447l-3-1.5a1 1 0 01-.447-1.342l1.738-3.476-1.233-.617a1 1 0 01.894-1.789l1.599.799L9 4.323V3a1 1 0 011-1z" />
        </svg>
      ),
      path: '/dashboard/ai-generator'
    }
  ]

  const bottomItems = [
    {
      id: 'developer-api',
      name: 'Developer API',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      ),
      path: '/dashboard/developer-api'
    },
    {
      id: 'apps',
      name: 'Apps',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
        </svg>
      ),
      path: '/apps'
    },
    {
      id: 'trash',
      name: 'Trash',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" clipRule="evenodd" />
          <path fillRule="evenodd" d="M10 5a2 2 0 00-2 2v6a2 2 0 002 2h4a2 2 0 002-2V7a2 2 0 00-2-2H10z" clipRule="evenodd" />
        </svg>
      ),
      path: '/trash'
    }
  ]

  const handleItemClick = (item) => {
    setActiveItem(item.id)

    // Handle dashboard routes
    if (['dashboard', 'my-templates', 'all-templates', 'templates', 'calendar', 'photos', 'graphics', 'audio', 'videos', 'template-management', 'multi-template-generator', 'ai-generator', 'category-management', 'tenant-management', 'user-management', 'tenant-template-management', 'tenant-watermark-templates', 'font-preview', 'developer-api'].includes(item.id)) {
      // Navigate to the specific dashboard route
      const routeMap = {
        'dashboard': '/dashboard',
        'my-templates': '/dashboard/my-templates',
        'all-templates': '/dashboard/all-templates',
        'templates': '/dashboard/templates',
        'calendar': '/dashboard/calendar',
        'photos': '/dashboard/photos',
        'graphics': '/dashboard/graphics',
        'audio': '/dashboard/audio',
        'videos': '/dashboard/videos',
        'template-management': '/dashboard/manage-templates',
        'multi-template-generator': '/dashboard/multi-template-generator',
        'ai-generator': '/dashboard/ai-generator',
        'category-management': '/dashboard/categories',
        'tenant-management': '/dashboard/tenants',
        'user-management': '/dashboard/users',
        'tenant-template-management': '/dashboard/template-assignments',
        'tenant-watermark-templates': '/dashboard/tenant-watermark-templates',
        'font-preview': '/dashboard/font-preview',
        'developer-api': '/dashboard/developer-api'
      }
      navigate(routeMap[item.id] || '/dashboard')
    } else {
      navigate(item.path)
    }
  }

  return (
    <aside className={`bg-white border-r border-gray-200 transition-all duration-300 ${
      isCollapsed ? 'w-16' : 'w-64'
    } flex flex-col h-full`}>
      {/* Main Navigation */}
      <nav className="flex-1 px-3 py-4 space-y-1">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => handleItemClick(item)}
            className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
              activeItem === item.id
                ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700'
                : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
            }`}
            title={isCollapsed ? item.name : ''}
          >
            <span className={`${activeItem === item.id ? 'text-blue-700' : 'text-gray-500'}`}>
              {item.icon}
            </span>
            {!isCollapsed && (
              <span className="ml-3 truncate">{item.name}</span>
            )}
          </button>
        ))}

        {/* Divider */}
        <div className="py-4">
          <div className="border-t border-gray-200"></div>
        </div>

        {/* Create Section */}
        {!isCollapsed && (
          <div className="space-y-2">
            <button
              onClick={() => navigate('/templates/create')}
              className="w-full flex items-center px-3 py-2 text-sm font-medium text-white bg-gradient-to-r from-purple-500 to-blue-600 rounded-lg hover:from-purple-600 hover:to-blue-700 transition-all duration-200"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
              </svg>
              <span className="ml-3">Create a design</span>
            </button>
          </div>
        )}

        {/* Admin Section */}
        {isAdmin && (
          <>
            <div className="py-4">
              <div className="border-t border-gray-200"></div>
            </div>

            {!isCollapsed && (
              <div className="px-3 py-2">
                <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                  Admin
                </h3>
              </div>
            )}

            {adminItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleItemClick(item)}
                className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
                  activeItem === item.id
                    ? 'bg-red-50 text-red-700 border-r-2 border-red-700'
                    : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                }`}
                title={isCollapsed ? item.name : ''}
              >
                <span className={`${activeItem === item.id ? 'text-red-700' : 'text-gray-500'}`}>
                  {item.icon}
                </span>
                {!isCollapsed && (
                  <span className="ml-3 truncate">{item.name}</span>
                )}
              </button>
            ))}
          </>
        )}
      </nav>

      {/* Bottom Navigation */}
      <div className="px-3 py-4 border-t border-gray-200 space-y-1">
        {bottomItems.map((item) => (
          <button
            key={item.id}
            onClick={() => handleItemClick(item)}
            className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
              activeItem === item.id
                ? 'bg-blue-50 text-blue-700'
                : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
            }`}
            title={isCollapsed ? item.name : ''}
          >
            <span className={`${activeItem === item.id ? 'text-blue-700' : 'text-gray-500'}`}>
              {item.icon}
            </span>
            {!isCollapsed && (
              <span className="ml-3 truncate">{item.name}</span>
            )}
          </button>
        ))}
      </div>
    </aside>
  )
}

export default SideNav
